import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, BookOpen, Clock, RefreshCw, Palette } from 'lucide-react';
const benefits = [{
  emoji: '📚',
  bg: 'bg-violet-100',
  border: 'border-violet-300',
  highlight: 'text-violet-600',
  label: '250 recetas rápidas',
  rest: ', divididas en desayunos, almuerzos, meriendas, cenas y snacks.'
}, {
  emoji: '⚡',
  bg: 'bg-orange-100',
  border: 'border-orange-300',
  highlight: 'text-orange-500',
  label: 'Listas en 15 minutos o menos',
  rest: ' para padres ocupados.'
}, {
  emoji: '🔄',
  bg: 'bg-emerald-100',
  border: 'border-emerald-300',
  highlight: 'text-emerald-600',
  label: 'Variantes inteligentes',
  rest: ' para rotar ingredientes según lo que tengas en la heladera.'
}, {
  emoji: '🎨',
  bg: 'bg-pink-100',
  border: 'border-pink-300',
  highlight: 'text-pink-500',
  label: 'Guía de texturas y colores',
  rest: ' para asegurar que el camuflaje funcione siempre.'
}];
export function BenefitsSection() {
  return <section className="py-20 bg-emerald-50" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-3">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-4">
            <h2 className="text-4xl md:text-6xl font-extrabold leading-tight mb-8" data-id="element-5">
              <span className="text-violet-600" data-id="element-6">Todo lo que necesitás</span>{' '}
              <span className="text-gray-900" data-id="element-7">para</span>{' '}
              <span className="bg-gradient-to-r from-orange-500 via-violet-600 to-emerald-500 bg-clip-text text-transparent" data-id="element-8">
                transformar la alimentación
              </span>{' '}
              <span className="text-gray-900" data-id="element-9">de tu familia</span>
            </h2>

            <div className="space-y-4" data-id="element-10">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className={`flex items-start gap-4 ${benefit.bg} border ${benefit.border} rounded-2xl p-4`} data-id="element-11">
                  <div className="flex-shrink-0 text-3xl leading-none mt-0.5" data-id="element-12">
                    {benefit.emoji}
                  </div>
                  <p className="text-base font-semibold text-gray-700 leading-snug" data-id="element-13">
                    <span className={`font-extrabold ${benefit.highlight}`} data-id="element-14">
                      {benefit.label}
                    </span>
                    {benefit.rest}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative flex items-center justify-center" data-id="element-15">
            <img src="https://cdn.magicpatterns.com/uploads/a3aPxYG4yGuFNsauDxmcqF/MOCKUP2heylloyd-image-1771694073078.png" alt="Recetas Rápidas para Niños que Odian las Verduras en laptop y celular" className="w-full rounded-3xl shadow-xl" data-id="element-16" />
          </motion.div>
        </div>
      </div>
    </section>;
}